export const PL9_HARDWARE_REQUEST = "PL9_HARDWARE_REQUEST";
export const PL9_HARDWARE_SUCCESS = "PL9_HARDWARE_SUCCESS";
export const PL9_HARDWARE_FAILURE = "PL9_HARDWARE_FAILURE";


export const DELETE_PL9_HARDWARE_REQUEST = "DELETE_PL9_HARDWARE_REQUEST";
export const DELETE_PL9_HARDWARE_SUCCESS = "DELETE_PL9_HARDWARE_SUCCESS";
export const DELETE_PL9_HARDWARE_FAILURE = "DELETE_PL9_HARDWARE_FAILURE";

export const GET_FAILED_USERS_REQUEST = "GET_FAILED_USERS_REQUEST";
export const GET_FAILED_USERS_SUCCESS = "GET_FAILED_USERS_SUCCESS";
export const GET_FAILED_USERS_FAILURE = "GET_FAILED_USERS_FAILURE";

export const DELETE_FAILED_USERS_REQUEST = "DELETE_FAILED_USERS_REQUEST";
export const DELETE_FAILED_USERS_SUCCESS = "DELETE_FAILED_USERS_SUCCESS";
export const DELETE_FAILED_USERS_FAILURE = "DELETE_FAILED_USERS_FAILURE";

export const GET_FAILED_USERS_LENGTH_REQUEST = "GET_FAILED_USERS_LENGTH_REQUEST";
export const GET_FAILED_USERS_LENGTH_SUCCESS = "GET_FAILED_USERS_LENGTH_SUCCESS";
export const GET_FAILED_USERS_LENGTH_FAILURE = "GET_FAILED_USERS_LENGTH_FAILURE";
